import { type State } from './types';

export const getPatient = ({ patients }: { patients: State }) =>
  patients.patient;
